/**
 * Robust URL builder for SmallApp REST endpoints.
 *
 * Why this exists: `new URL(path, base)` follows RFC 3986 — a `path` starting
 * with `/` is an "absolute path-reference" that REPLACES the base's path
 * entirely, keeping only the origin. SmallApp manifests often declare paths
 * with leading `/` (natural REST convention) while `appMeta.apiUrl` may or
 * may not have a trailing `/`, giving four combinations and only ONE produces
 * the intended URL:
 *
 *   path='/foo', apiUrl='.../api/iock'   → 'https://x/foo'                ❌ drops /api/iock
 *   path='/foo', apiUrl='.../api/iock/'  → 'https://x/foo'                ❌ same
 *   path='foo',  apiUrl='.../api/iock'   → 'https://x/api/foo'            ❌ drops 'iock'
 *   path='foo',  apiUrl='.../api/iock/'  → 'https://x/api/iock/foo'       ✓
 *
 * This helper normalises both inputs: strips trailing slashes from apiUrl,
 * strips leading slashes from path, and joins with a single `/`. Result is
 * stable regardless of whether the manifest/DB carried the slashes correctly.
 *
 * Related: `moderation-rest.ts` has a private `withTrailingSlash(apiUrl)` that
 * normalises only the apiUrl side and relies on callers passing leading-slash-
 * free paths. `buildSmallAppUrl` is stricter — it also strips leading slashes
 * from `path`, so it is safe to use even when the manifest declares paths with
 * a leading `/` (REST convention). Prefer THIS helper for new code; consider
 * migrating moderation-rest.ts to converge on a single normaliser.
 */
export function buildSmallAppUrl(apiUrl: string, path: string): string {
  return `${apiUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
